// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__TClth","file":"styles_file__2_cS7"};